import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'
import { SecondaryOpacityTrailerButtonSC } from './SecondaryOpacityTrailerButton.styled'

export interface ISecondaryOpacityTrailerButtonProps extends IButtonProps {
  primary?: boolean
}

export const SecondaryOpacityTrailerButton = ({
  title = '',
  primary = false,
  corners = ButtonCorners.CORNERS_PILL,
  paddings = [FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_100],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_TEXT_TERTIARY,
  backgroundColorDefault = primary
    ? COLOR.BUTTON_ACCENT_PRIMARY
    : COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = primary
    ? COLOR.SURFACE_OPACITY_LIGHT_15
    : COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_DARK_25,
  backgroundColorDisabled = COLOR.SURFACE_DARK_5,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.FontSmBold,
  fluid = ButtonFluid.None,
  ...rest
}: ISecondaryOpacityTrailerButtonProps): JSX.Element | null =>
  title ? (
    <SecondaryOpacityTrailerButtonSC
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      title={title}
      icon={IconNames.floatingVideo}
      iconPosition={IconPositions.Center}
      iconSize={ButtonIconSizes.xSm}
      ariaLabel={title}
      {...rest}
    />
  ) : null
